export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10519.2ca6ba4e.jpg";